import { render, staticRenderFns } from "./DetailModal.vue?vue&type=template&id=0de9878c&scoped=true&"
import script from "./DetailModal.vue?vue&type=script&lang=ts&"
export * from "./DetailModal.vue?vue&type=script&lang=ts&"
import style0 from "./DetailModal.vue?vue&type=style&index=0&id=0de9878c&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0de9878c",
  null
  
)

export default component.exports